import { ObjectCategory } from '../Constants';
export const isFileMap = file => {
  return 'get' in file && file.get('category') === ObjectCategory.FILE;
};
export const fileMapToPublicFMFile = file => file.toJS();

// This type was added to support the legacy FileUploadComponent in `FileManagerLib`.
// Use the FileMap type above or types declared in `file-manager-components for new code.
// Those types more accurately represent the data structure of the returned data object.
// safe to cast a FileMap to this when `type` is `IMG`
// safe to cast a FileMap to this when `type` is `MOVIE`